module.exports = __webpack_public_path__ + "img/Team_Working.d09db1ce.png";